"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = number;
var _constants = require("../resources/constants");
/**
 * Only to be used with treeGroup category translates
 * @param  {string} value
 * @param  {string} category 'treeGroup'
 * @returns {number} 65
 */

function number(_ref) {
  var value = _ref.value,
    category = _ref.category;
  var translate_number = 0;
  if (category === _constants.CATEGORY.treeGroup) {
    translate_number = value / 10000000; // a single tree absorbs 10kg of co2 a year
  }

  return {
    number: translate_number
  };
}

// NEW RESEACH (MAYBE USE IN NEAR FUTURE): 1814366mg of CO2 absorbed by a single tree in one month (https://www.co2meter.com/blogs/news/could-global-co2-levels-be-reduced-by-planting-trees)
//# sourceMappingURL=index.js.map